import Shepherd from "shepherd.js";
import { tourChecker, addTourToQueue } from "@/lib/tour";

export const startTour = ({ check = true, options = {} } = {}) => {
  const tourName = "SideNav";
  // console.warn("Started Tour of ", tourName);

  // If tour has been shown before and check is true, don't show it.
  if (check && tourChecker(tourName)) return;

  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    exitOnEsc: true,
    tourName,
    ...options,
  });

  /**
   * Adding Grid Property or Function
   */
  tour.addSteps([
    {
      attachTo: { element: ".side-nav-bar a[href='/dashboards']", on: "right" },
      canClickTarget: false,
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text:
        "<strong>List of Dashboards:</strong><br/>Check the KPI dashboards built by your team.",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: { element: ".side-nav-bar a[href='/entities']", on: "right" },
      canClickTarget: false,
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text:
        "<strong>Entity List:</strong><br/>Get list & detailed profiles of all entites",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: { element: ".side-nav-bar a[href='/analysis']", on: "right" },
      canClickTarget: false,
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text:
        "<strong>Station Performance:</strong><br/>Measure how static locations perform",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: {
        element: ".side-nav-bar a[href='/supply_demand']",
        on: "right",
      },
      canClickTarget: false,
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text:
        "<strong>Mismatch Analysis:</strong><br/>Analyse unfulfilled demand vs available supply",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: {
        element: ".side-nav-bar a[href='/trip_analysis']",
        on: "right",
      },
      canClickTarget: false,
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text:
        "<strong>Journey of Entity:</strong><br/>Analyse trips or deliveries on different KPIs",
      buttons: [
        {
          text: "Skip",
          secondary: true,
          action: tour.complete,
        },
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Next",
          action: tour.next,
        },
      ],
    },
    {
      attachTo: { element: ".side-nav-bar a[href='/life_cycle']", on: "right" },
      canClickTarget: false,
      popperOptions: {
        modifiers: [{ name: "offset", options: { offset: [15, 15] } }],
      },
      text:
        "<strong>Events of Entity:</strong><br/>Measure user churn & time spent in different steps",
      buttons: [
        {
          text: "Back",
          secondary: true,
          action: tour.back,
        },
        {
          text: "Done",
          action: tour.next,
        },
      ],
    },
  ]);

  addTourToQueue(tour, tourName);
};
